module.exports = __webpack_public_path__ + "img/ilongame.06e8cb74.png";